// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3jTKZ","content":"styles_content__1FQdr","selectAll":"styles_selectAll__vVcVP"};